<script>
  import SearchSelect from "@/core/components/SearchSelect"
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import {
    faTimesCircle,
    faArrowUp,
    faArrowDown,
    faChevronDown,
    faChevronUp,
    faCheck,
    faTimes,
    faMap,
  } from "@fortawesome/free-solid-svg-icons"
  import L from "leaflet"
  import { LMap, LTileLayer, LMarker, LIcon, LTooltip, LPolyline } from "vue2-leaflet"
  import { Money } from "v-money"

  // Importação assíncrona do componente CreateSectionPoint
  const CreateSectionPoint = () =>
    import("@/domains/lines/views/sectionPoints/CreateSectionPoint.vue")

  export default {
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LIcon,
      LTooltip,
      LPolyline,
      FontAwesomeIcon,
      SearchSelect,
      Money,
      CreateSectionPoint,
    },

    props: {
      lineModel: {
        type: Object,
        required: true,
      },
      sectionPointsForm: {
        type: Array,
        required: true,
      },
      patamar: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        // Ícones do FontAwesome
        faChevronDown,
        faChevronUp,
        faCheck,
        faTimes,
        faMap,
        faArrowUp,
        faArrowDown,
        faTimesCircle,
        // Dados do formulário e estado
        idpontosecao: 0,
        city: null,
        origin: null,
        destiny: null,
        isSection: false,
        isSectioning: false,
        isSelect: true,
        isMap: false,
        isMarkers: false,
        loader: false,
        loaderMap: false,
        showCreateModal: false,
        // Configurações do mapa
        zoom: 7.5,
        center: L.latLng(-27.597456, -48.53366),
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        withPopup: L.latLng(47.41322, -1.219482),
        withTooltip: L.latLng(47.41422, -1.250482),
        currentZoom: 7.5,
        currentCenter: L.latLng(-27.597456, -48.53366),
        showParagraph: false,
        mapOptions: {
          zoomSnap: 0.5,
          scrollWheelZoom: true,
        },
        // Ícones do mapa
        icon: L.icon({
          iconUrl:
            "https://www.shareicon.net/data/512x512/2016/05/29/772542_interface_512x512.png",
          iconSize: [48, 48],
          iconAnchor: [16, 37],
        }),
        staticAnchor: [16, 37],
        customText: "Foobar",
        iconSize: [38, 38],
        firstIcon:
          "https://www.shareicon.net/data/512x512/2016/05/29/772542_interface_512x512.png",
        middleIcon:
          "https://www.shareicon.net/data/512x512/2016/05/29/772542_interface_512x512.png",
        lastIcon:
          "https://www.shareicon.net/data/512x512/2016/05/29/772542_interface_512x512.png",
        // Estado do mapa
        showMap: false,
        loadTimeMap: true,
        loaderSearch: false,
        messageAlert: false,
        typePoint: "",
        showMiniMap: false,
        // Dados dinâmicos
        markersForm: [],
        sections: [],
        localPatamar: this.patamar,
        levels: [],
        // Formatos de entrada
        kilometer: {
          decimal: ",",
          thousands: ".",
          suffix: " Km",
          precision: 3,
        },
        minutes: {
          decimal: ",",
          thousands: ".",
          suffix: " Min",
          precision: 0,
        },
        price: {
          decimal: ",",
          thousands: ".",
          prefix: "R$ ",
          precision: 2,
        },
      }
    },

    computed: {
      // Retorna os marcadores do modelo de linha
      markersModel() {
        return this.lineModel.markers
      },
      // Retorna as seções do modelo de linha
      sectionsModel() {
        return this.lineModel.sections
      },
      linePoints() {
        return this.markersForm.map(marker => [
          marker.lat,
          marker.lng
        ])
      },
    },

    watch: {
      // Observa mudanças na origem para ativar isSection e gerar seções
      origin(newVal) {
        if (!newVal || !newVal.nmlocalidade || newVal.nmlocalidade.length < 3)
          return
        if (newVal && this.destiny) {
          this.isSection = true
          this.generateSectioning()
        }
      },
      // Observa mudanças no destino para ativar isSection e gerar seções
      destiny(newVal) {
        if (newVal && this.origin) {
          this.isSection = true
          this.generateSectioning()
        }
      },
      // Observa mudanças nos marcadores do modelo
      markersModel(newVal) {
        if (newVal && newVal.length > 0) {
          this.markersForm = newVal.map((marker) => {
            if (marker.gelng && marker.gelat) {
              marker.name = marker.nmlocalidade
              marker.lat = marker.gelat
              marker.lng = marker.gelng
            }
            return marker
          })
        }
      },
      patamar(newVal) {
        this.localPatamar = newVal
      },
      // Observa mudanças na lista de marcadores
      markersForm: {
        handler: function () {
          this.generateSectioning()
        },
        deep: true,
      },
      // Observa mudanças nos pontos de seção
      sectionPointsForm: {
        handler: function (newSectionPoints) {
          this.handleSectionPointsChange(newSectionPoints)
        },
        deep: true,
      },
      // Observa mudanças nas seções do modelo
      sectionsModel: {
        handler: function () {
          if (this.sectionsModel.length > 0 && this.sectionsModel[0].idsecao) {
            this.setUpSectionPoints(this.sectionsModel)
            this.$emit("update-section-points", this.sectionsModel) // Atualizar via evento
            this.showMode()
            this.levels = this.lineModel.levels
            const hasPatamar = this.sectionsModel.find(
              (i) => i.tariff_coefficient_value !== null
            )
            if (hasPatamar) {
              this.localPatamar = true
              this.$emit("update:patamar", this.localPatamar)
            }
          }
        },
        deep: true,
      },
    },

    methods: {
      // Adiciona um ponto de seção à lista de marcadores
      addSectionPoint() {
        if (this.city && this.city.nmlocalidade) {
          this.markersForm.push({
            id: this.city.idpontosecao,
            name: this.city.nmlocalidade,
            description: this.city.delocalidade,
            lat: this.city.gelat,
            lng: this.city.gelng,
          })
          this.isSection = true
          this.generateSectioning()
        }
      },
      // Manipula o evento de criação de um novo ponto de seção
      handleSectionPointCreated(newSectionPoint) {
        this.city = newSectionPoint
        this.showCreateModal = false
      },
      // Fecha o modal ao clicar fora dele
      closeModalOnOutsideClick(event) {
        if (event.target.classList.contains("bg-black")) {
          this.showCreateModal = false
        }
      },
      setUpSectionPoints(points) {
        const formattedPoints = points.map((point) => {
          if (this.localPatamar) {
            const levelSelected = this.levels.find(
              (level) => level.id === point.nuvalorcoeficientetarifa
            )
            if (!levelSelected) return

            // Verificação detalhada
            const levelValue = parseFloat(
              levelSelected.value.replace(".", "").replace(",", ".")
            )
            const vlcoeficiente =
              parseFloat(String(point.vlcoeficiente).replace(",", ".")) ||
              parseFloat(String(this.lineModel.vlcoeficiente).replace(",", "."))
            const vlarredondadotarifa =
              this.lineModel.deter_registry.tariff_coefficient[0]
                .vlarredondamentotarifa

            if (
              isNaN(levelValue) ||
              isNaN(vlcoeficiente) ||
              isNaN(vlarredondadotarifa)
            ) {
              this.$toast.error({
                title: "Erro",
                message: "Valores inválidos nos cálculos de tarifa.",
              })
              return
            }

            const vloriginal = levelValue
            const vlcoeficientemultiplicacao = vlcoeficiente * levelValue
            let vlarredondado = vlcoeficientemultiplicacao

            if (vlarredondadotarifa > 0) {
              vlarredondado =
                Math.round(vlcoeficientemultiplicacao / vlarredondadotarifa) *
                vlarredondadotarifa
            }

            point.nuvalorcoeficientetarifa = levelSelected.id
            point.vloriginal = vloriginal
            point.vlcoeficientemultiplicacao = vlcoeficientemultiplicacao
            point.vlarredondado = vlarredondado
            if (point.flrestrito == 1) {
              point.vlpreco = 0
            } else {
              point.vlpreco = vlarredondado.toFixed(2).replace(".", ",")
            }
          } else {
            point.vlcoeficientemultiplicacao = (
              point.vloriginal * Number(point.vlcoeficiente)
            ).toFixed(2)
            const vlarredondadotarifa =
              this.lineModel.deter_registry.tariff_coefficient[0]
                .vlarredondamentotarifa
            let vlarredondado = point.vlcoeficientemultiplicacao

            if (vlarredondadotarifa > 0) {
              vlarredondado = (
                Math.round(
                  point.vlcoeficientemultiplicacao / vlarredondadotarifa
                ) * vlarredondadotarifa
              ).toFixed(2)
            }
            point.vlarredondado = vlarredondado

            let precoformatted

            if (point.flvalormanual == 1) {
              if (point.vlprecomanual) {
                precoformatted = point.vlprecomanual.toFixed(2)
              } else if (typeof point.vlpreco === "string") {
                precoformatted = point.vlpreco
              } else {
                precoformatted = point.vlpreco.toFixed(2)
              }
            } else {
              precoformatted = point.vlarredondado
            }

            if (
              Number(point.vlminimo) > Number(precoformatted) &&
              point.flvalormanual != "1"
            ) {
              precoformatted = Number(point.vlminimo).toFixed(2)
            }

            if (point.flrestrito == 1) {
              point.vlpreco = 0
            } else {
              point.vlpreco = precoformatted.replace(".", ",")
            }
          }
        })
        this.$emit("update-section-points", formattedPoints)
      },
      // Gera as seções com base nos marcadores
      generateSectioning() {
        const oldSections = [...this.sections] || []
        this.sections = []
        if (!this.isSectioning) {
          if (!this.origin || !this.destiny) return

          if (this.markersForm.length === 0) {
            this.sections.push({
              origin_id: this.origin.idpontosecao,
              destiny_id: this.destiny.idpontosecao,
              description:
                this.origin.nmlocalidade + " - " + this.destiny.nmlocalidade,
              origin: this.origin.nmlocalidade,
              destiny: this.destiny.nmlocalidade,
              origin_point: this.origin,
              destiny_point: this.destiny,
              nukmpavimentacao:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.origin.nmlocalidade + " - " + this.destiny.nmlocalidade
                )?.nukmpavimentacao || 0,
              nukmterra:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.origin.nmlocalidade + " - " + this.destiny.nmlocalidade
                )?.nukmterra || 0,
              nutempopercurso:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.origin.nmlocalidade + " - " + this.destiny.nmlocalidade
                )?.nutempopercurso || 0,
            })
          } else {
            this.sections.push({
              origin_id: this.origin.idpontosecao,
              destiny_id: this.markersForm[0].id,
              description:
                this.origin.nmlocalidade + " - " + this.markersForm[0].name,
              origin: this.origin.nmlocalidade,
              destiny: this.markersForm[0].name,
              origin_point: this.origin,
              destiny_point: this.markersForm[0],
              nukmpavimentacao:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.origin.nmlocalidade + " - " + this.markersForm[0].name
                )?.nukmpavimentacao || 0,
              nukmterra:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.origin.nmlocalidade + " - " + this.markersForm[0].name
                )?.nukmterra || 0,
              nutempopercurso:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.origin.nmlocalidade + " - " + this.markersForm[0].name
                )?.nutempopercurso || 0,
            })

            this.markersForm.forEach((marker, index) => {
              if (index > 0) {
                this.sections.push({
                  origin_id: this.markersForm[index - 1].id,
                  origin: this.markersForm[index - 1].name,
                  destiny: marker.name,
                  destiny_id: marker.id,
                  origin_point: this.markersForm[index - 1],
                  destiny_point: this.marker,
                  description:
                    this.markersForm[index - 1].name + " - " + marker.name,
                  nukmpavimentacao:
                    oldSections.find(
                      (s) =>
                        s.description ===
                        this.markersForm[index - 1].name + " - " + marker.name
                    )?.nukmpavimentacao || 0,
                  nukmterra:
                    oldSections.find(
                      (s) =>
                        s.description ===
                        this.markersForm[index - 1].name + " - " + marker.name
                    )?.nukmterra || 0,
                  nutempopercurso:
                    oldSections.find(
                      (s) =>
                        s.description ===
                        this.markersForm[index - 1].name + " - " + marker.name
                    )?.nutempopercurso || 0,
                })
              }
            })

            this.sections.push({
              origin_id: this.markersForm[this.markersForm.length - 1].id,
              destiny_id: this.destiny.idpontosecao,
              description:
                this.markersForm[this.markersForm.length - 1].name +
                " - " +
                this.destiny.nmlocalidade,
              origin: this.markersForm[this.markersForm.length - 1].name,
              destiny: this.destiny.nmlocalidade,
              origin_point: this.markersForm[this.markersForm.length - 1],
              destiny_point: this.destiny,
              nukmpavimentacao:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.markersForm[this.markersForm.length - 1].name +
                      " - " +
                      this.destiny.nmlocalidade
                )?.nukmpavimentacao || 0,
              nukmterra:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.markersForm[this.markersForm.length - 1].name +
                      " - " +
                      this.destiny.nmlocalidade
                )?.nukmterra || 0,
              nutempopercurso:
                oldSections.find(
                  (s) =>
                    s.description ===
                    this.markersForm[this.markersForm.length - 1].name +
                      " - " +
                      this.destiny.nmlocalidade
                )?.nutempopercurso || 0,
            })
          }
        }
      },
      // Move um ponto de seção para cima na lista
      sectionPointUp(index) {
        if (index > 0) {
          const temp1 = this.markersForm[index]
          const temp2 = this.markersForm[index - 1]
          this.$set(this.markersForm, index - 1, temp1)
          this.$set(this.markersForm, index, temp2)
        }
      },
      // Move um ponto de seção para baixo na lista
      sectionPointDown(index) {
        if (index < this.markersForm.length - 1) {
          const temp1 = this.markersForm[index]
          const temp2 = this.markersForm[index + 1]
          this.$set(this.markersForm, index + 1, temp1)
          this.$set(this.markersForm, index, temp2)
        }
      },
      // Ativa o modo de visualização de secionamento
      showMode() {
        this.isSectioning = true
        this.isSelect = false
        this.isSection = false
        this.isMarkers = false
      },
      // Ativa o modo de edição do secionamento
      EditMode() {
        if (this.sectionPointsForm.length === 0) {
          return
        }

        // Backup do coeficiente atual antes de reconstruir dados
        const coefBackup = this.lineModel.vlcoeficientemultiplicacao

        const sortedSections = [...this.sectionPointsForm].sort(
          (a, b) => parseInt(a.nusequencia) - parseInt(b.nusequencia)
        )

        // Reconstruir percurso completo com objetos únicos
        const percurso = [
          sortedSections[0].origin_point || {
            idpontosecao: sortedSections[0].origin_id,
            nmlocalidade: sortedSections[0].origin_name,
          },
          ...sortedSections.map(
            (s) =>
              s.destiny_point || {
                idpontosecao: s.destiny_id,
                nmlocalidade: s.destiny_name,
              }
          ),
        ]

        // Remove duplicatas por ID
        const vistos = new Set()
        const percursoUnico = percurso.filter((p) => {
          const id = p.idpontosecao
          if (vistos.has(id)) return false
          vistos.add(id)
          return true
        })

        // Reatribuir origem, destino e intermediários
        this.origin = this.lineModel.origin_point || percursoUnico[0]

        this.destiny =
          this.lineModel.destiny_point ||
          percursoUnico[percursoUnico.length - 1]

        this.markersForm = percursoUnico.slice(1, -1).map((p) => ({
          id: p.idpontosecao,
          name: p.nmlocalidade,
          description: p.delocalidade || "",
          lat: p.gelat || null,
          lng: p.gelng || null,
        }))

        // Também recria a lista de seções para exibição
        this.sections = sortedSections.map((section) => ({
          origin_id: section.origin_id,
          destiny_id: section.destiny_id,
          origin: section.origin_name,
          destiny: section.destiny_name,
          origin_point: section.origin_point,
          destiny_point: section.destiny_point,
          description: `${section.origin_name} - ${section.destiny_name}`,
          nukmpavimentacao: section.nukmpavimentacao || 0,
          nukmterra: section.nukmterra || 0,
          nutempopercurso: section.nutempopercurso || 0,
        }))

        // Restaura o coeficiente após reconstrução
        this.lineModel.vlcoeficientemultiplicacao =
          this.lineModel.vlcoeficientemultiplicacao || coefBackup

        this.isSectioning = false
        this.isSelect = true
        this.isSection = true
        this.isMarkers = true
        this.isEdit = true
      },
      cancelEdition() {
        this.isSectioning = true
        this.isSelect = false
        this.isSection = false
        this.isMarkers = false
      },
      // Gera o secionamento e atualiza o mapa
      generateSectioningAndMap() {
        this.showMode()
        this.isSectioning = true
        this.markersForm.unshift({
          id: this.origin.idpontosecao,
          name: this.origin.nmlocalidade,
          description: this.origin.delocalidade,
          lat: this.origin.gelat,
          lng: this.origin.gelng,
        })
        this.markersForm.push({
          id: this.destiny.idpontosecao,
          name: this.destiny.nmlocalidade,
          description: this.destiny.delocalidade,
          lat: this.destiny.gelat,
          lng: this.destiny.gelng,
        })
      },
      // Atualiza o nível de zoom do mapa
      zoomUpdate(zoom) {
        this.currentZoom = zoom
      },
      // Atualiza o centro do mapa
      centerUpdate(center) {
        this.currentCenter = center
      },
      // Alterna a visibilidade de um texto longo
      showLongText() {
        this.showParagraph = !this.showParagraph
      },
      // Fecha a seleção de seções
      closeSelectSessions() {
        this.hideCardMap = false
      },
      // Remove um ponto de seção da lista
      removeSectionPoint(index) {
        this.markersForm.splice(index, 1)
        this.generateSectioning()
      },
      calcSectionPrice(section) {
        const tpoperacao = this.lineModel.tpoperacao - 1

        const pavTariffObj = this.lineModel.tariffs?.find(
          (i) => i.tipopreco === tpoperacao * 2 + 1
        )
        const terraTariffObj = this.lineModel.tariffs?.find(
          (i) => i.tipopreco === tpoperacao * 2 + 2
        )

        const pavTariff = pavTariffObj
          ? Number(pavTariffObj.value.replace(",", "."))
          : 0
        const terraTariff = terraTariffObj
          ? Number(terraTariffObj.value.replace(",", "."))
          : 0

        if (isNaN(pavTariff) || isNaN(terraTariff)) {
          section.vloriginal = 0
          return
        }

        section.vloriginal =
          section.nukmpavimentacao * pavTariff + section.nukmterra * terraTariff
      },
      changePatamar() {
        for (const section of this.sectionPointsForm) {
          const valorAntigo =
            section.nuvalorcoeficientetarifaeditando ||
            section.nuvalorcoeficientetarifa ||
            null
          const tarifaAntiga =
            section.tariff_coefficient_valueeditando ||
            section.tariff_coefficient_value ||
            null
          section.nuvalorcoeficientetarifaeditando =
            section.nuvalorcoeficientetarifa
          section.tariff_coefficient_valueeditando =
            section.tariff_coefficient_value
          section.nuvalorcoeficientetarifa = this.localPatamar
            ? valorAntigo
            : null
          section.tariff_coefficient_value = this.localPatamar
            ? tarifaAntiga
            : null

          if (this.localPatamar) {
            // Ao mudar para SIM, se não houver backup, cria um a partir do valor atual.
            if (section.vloriginal_backup === undefined) {
              section.vloriginal_backup = section.vloriginal
            }
          } else {
            // Ao mudar para NÃO, restaura o valor do backup, se existir.
            if (section.vloriginal_backup !== undefined) {
              section.vloriginal = section.vloriginal_backup
            } else {
              // Se não houver backup, recalcula (comportamento de segurança).
              this.calcSectionPrice(section)
            }
          }
        }
      },
      changePrice(value, result) {
        result.vlprecomanual = value
      },
      // Cria o secionamento fazendo uma requisição à API
      async createSeazoning() {
        if (!this.origin || !this.destiny) {
          this.$toast.error({
            title: "Erro",
            message: "Defina origem e destino antes de calcular.",
          })
          return
        }

        const coef = parseFloat(this.lineModel.vlcoeficientemultiplicacao)

        if (!coef || coef <= 0) {
          this.$toast.error({
            title: "Erro",
            message: "Coeficiente inválido.",
          })
          return
        }

        //Verifica se todos os pontos tem alguma quilometragem
        const noKilometer = this.sections.filter(
          (s) => s.nukmpavimentacao === 0 && s.nukmterra === 0
        )

        if (noKilometer && noKilometer.length > 0) {
          this.$toast.error({
            title: "Erro",
            message: "Seção sem quilometragem",
          })
          return
        }

        // Normaliza pontos
        const allPoints = [this.origin, ...this.markersForm, this.destiny].map(
          (p) => ({
            ...p,
            idpontosecao: p.idpontosecao || p.id || p.value,
            nmlocalidade: p.nmlocalidade || p.name,
          })
        )

        // Cria um mapa com os dados manuais preenchidos no formulário
        const manualMap = {}
        this.sections.forEach((sec) => {
          const key = `${sec.origin_id}_${sec.destiny_id}`
          manualMap[key] = {
            nukmpavimentacao: sec.nukmpavimentacao,
            nukmterra: sec.nukmterra,
            nutempopercurso: sec.nutempopercurso,
          }
        })

        this.sections = []

        for (let i = 0; i < allPoints.length - 1; i++) {
          const origin = allPoints[i]
          const destiny = allPoints[i + 1]

          const originId = Number(origin.idpontosecao)
          const destinyId = Number(destiny.idpontosecao)
          const key = `${originId}_${destinyId}`
          const manual = manualMap[key] || {}

          this.sections.push({
            origin_id: originId,
            destiny_id: destinyId,
            origin: origin.nmlocalidade,
            destiny: destiny.nmlocalidade,
            origin_point: origin,
            destiny_point: destiny,
            description: `${origin.nmlocalidade} - ${destiny.nmlocalidade}`,
            nukmpavimentacao: manual.nukmpavimentacao || 0,
            nukmterra: manual.nukmterra || 0,
            nutempopercurso: manual.nutempopercurso || 0,
          })
        }

        if (this.sections.length === 0) {
          this.$toast.error({
            title: "Erro",
            message: "Nenhum trecho válido encontrado.",
          })
          return
        }

        this.$Progress.start()
        try {
          const response = await this.$axios.post(
            `/api/lines/tariff-coefficient/calculate-sectioning/${this.lineModel.idlinha}`,
            {
              sectionPoints: this.sections,
              coeficiente: coef,
            }
          )

          const { sections: apiSections, levels } = response.data

          if (!apiSections || apiSections.length === 0) {
            const manualSections = this.sections.map((s, index) => {
              let nuvalorcoeficientetarifa = null
              if (
                this.sectionPointsForm &&
                this.sectionPointsForm.length > 0 &&
                this.localPatamar
              ) {
                nuvalorcoeficientetarifa =
                  this.sectionPointsForm.find((j) => {
                    return (
                      j.origin_point.idpontosecao ==
                        s.origin_point.idpontosecao &&
                      j.destiny_point.idpontosecao ==
                        s.destiny_point.idpontosecao
                    )
                  })?.nuvalorcoeficientetarifa || null
              }
              return {
                ...s,
                origin_name: s.origin,
                destiny_name: s.destiny,
                nusequencia: index + 1,
                vlcoeficiente: this.lineModel.vlcoeficientemultiplicacao,
                vlarredondadotarifa: 0,
                vlcoeficientemultiplicacao:
                  this.lineModel.vlcoeficientemultiplicacao,
                flrestrito: 0,
                flvalormanual: 0,
                vlpreco: "",
                vloriginal: "",
                vlarredondado: "",
                nuvalorcoeficientetarifa,
              }
            })

            this.$emit("update-section-points", manualSections)
          } else {
            const formattedSections = apiSections.map((s, index) => {
              let nuvalorcoeficientetarifa = null
              if (
                this.sectionPointsForm &&
                this.sectionPointsForm.length > 0 &&
                this.localPatamar
              ) {
                nuvalorcoeficientetarifa =
                  this.sectionPointsForm.find((j) => {
                    return (
                      j.origin_point.idpontosecao ==
                        s.origin_point.idpontosecao &&
                      j.destiny_point.idpontosecao ==
                        s.destiny_point.idpontosecao
                    )
                  })?.nuvalorcoeficientetarifa || null
              }
              return {
                ...s,
                origin_name: s.nupontoorigem_nome,
                destiny_name: s.nupontodestino_nome,
                nusequencia: index + 1,
                nuvalorcoeficientetarifa,
              }
            })

            this.$emit("update-section-points", formattedSections)
          }

          this.levels = levels || []
          // this.localPatamar = levels && levels.length > 0;
          // this.$emit('update:patamar', this.localPatamar);
          this.generateSectioningAndMap()
        } catch (error) {
          this.$toast.error({
            title: "Erro",
            message: error.response?.data?.error || "Erro inesperado.",
          })
        } finally {
          this.$Progress.finish()
        }
      },
      // Emite evento de mudança nos pontos de seção
      handleSectionPointsChange(newSectionPoints) {
        this.$emit("update-section-points", newSectionPoints)
      },
      formatCurrencyBR(value) {
        return value.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        })
      },
      // Manipula a seleção de coeficiente de tarifa
      handleSelectionChange(result, index) {
        const levelSelected = this.levels.find(
          (level) => level.id === result.nuvalorcoeficientetarifa
        )
        if (!levelSelected) return

        // Verificação detalhada
        const levelValue = parseFloat(
          levelSelected.value.replace(".", "").replace(",", ".")
        )
        const vlcoeficiente = parseFloat(
          String(this.sectionPointsForm[0].vlcoeficiente).replace(",", ".")
        )
        const vlarredondadotarifa =
          this.lineModel.deter_registry.tariff_coefficient[0]
            .vlarredondamentotarifa

        if (
          isNaN(levelValue) ||
          isNaN(vlcoeficiente) ||
          isNaN(vlarredondadotarifa)
        ) {
          this.$toast.error({
            title: "Erro",
            message: "Erro: valores inválidos nos cálculos de tarifa.",
          })
          return
        }

        const vloriginal = levelValue
        const vlcoeficientemultiplicacao = vlcoeficiente * levelValue
        let vlarredondado = vlcoeficientemultiplicacao

        if (vlarredondadotarifa > 0) {
          vlarredondado =
            Math.round(vlcoeficientemultiplicacao / vlarredondadotarifa) *
            vlarredondadotarifa
        }

        this.sectionPointsForm[index].nuvalorcoeficientetarifa =
          levelSelected.id
        this.sectionPointsForm[index].vloriginal = vloriginal
        this.sectionPointsForm[index].vlcoeficientemultiplicacao =
          vlcoeficientemultiplicacao
        this.sectionPointsForm[index].vlarredondado = vlarredondado
        this.sectionPointsForm[index].vlpreco = vlarredondado
          .toFixed(2)
          .replace(".", ",")

        this.$emit("update-section-points", this.sectionPointsForm)
      },
    },
  }
</script>

<style>
  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }

  .item1 {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    padding: 12px;
  }
</style>
<template>
  <div>
    <form @submit.prevent="submitSectionPointForm">
      <!-- Título -->
      <h2 class="text-lg font-semibold text-green-800 mb-4">
        DESCRIÇÃO DA LINHA REGULAR
      </h2>

      <!-- Checkbox Patamarizada -->
      <div class="mb-4">
        <label class="form-label inline-flex items-center text-gray-700">
          <span class="mr-2">Esta linha é patamarizada?</span>
        </label>
      </div>
      <div class="mb-4">
        <input
          type="radio"
          v-model="localPatamar"
          :value="true"
          @change="changePatamar()"
          class="form-radio h-4 w-4 text-green-600"
          style="border: 1px solid #595858 !important;"
        >
        <span class="ml-1 mr-4">SIM</span>
        <input
          type="radio"
          v-model="localPatamar"
          :value="false"
          @change="changePatamar()"
          class="form-radio h-4 w-4 text-green-600"
          style="border: 1px solid #595858 !important;"
        >
        <span class="ml-1">NÃO</span>
      </div>

      <!-- Seleção de Origem e Destino -->
      <div class="grid gap-5 md:grid-cols-12 mb-4" v-if="isSelect">
        <div class="col-span-6">
          <label class="form-label text-gray-700" for="origem">ORIGEM</label>
          <SearchSelect
            :selected.sync="origin"
            :search-keys="[]"
            :search-remote="true"
            :lazy-load="true"
            :option-value="city =>
              `${city?.nmlocalidade} - ${(city?.city?.nmmunicipio || '')}`"
            :digits-before-search="3"
            options-url="/api/lines/section-point/search/"
            option-key="idpontosecao"
            field-class="py-3"
            name="nmlocalidade"
            placeholder="Selecione um ponto de origem..."
            class="form-input border-gray-300 rounded-md w-full"
            @changed="isMarkers = true"
          />
        </div>
        <div class="col-span-6">
          <label class="form-label text-gray-700" for="destino">DESTINO</label>
          <SearchSelect
            :selected.sync="destiny"
            :search-keys="[]"
            :search-remote="true"
            :lazy-load="true"
            :option-value="city =>
              `${city?.nmlocalidade} - ${(city?.city?.nmmunicipio || '')}`"
            :digits-before-search="3"
            options-url="/api/lines/section-point/search/"
            option-key="idpontosecao"
            field-class="py-3"
            name="nmlocalidade"
            placeholder="Selecione um ponto de destino..."
            class="form-input border-gray-300 rounded-md w-full"
            @changed="isMarkers = true"
          />
        </div>
      </div>

      <!-- Seleção de Ponto de Seção -->
      <div class="grid gap-3 md:grid-cols-12 mb-4 items-center" v-if="isSelect">
        <div class="col-span-8">
          <label class="form-label text-gray-700 mb-1 block" for="sectionPoint">
            PONTO DE SEÇÃO
          </label>
          <SearchSelect
            :selected.sync="city"
            :search-keys="[]"
            :search-remote="true"
            :lazy-load="true"
            :option-value="city =>
              `${city?.nmlocalidade} - ${(city?.city?.nmmunicipio || '')}`"
            :digits-before-search="3"
            options-url="/api/lines/section-point/search/"
            option-key="idpontosecao"
            field-class="py-2.5"
            name="nmlocalidade"
            placeholder="Selecione um ponto de seção..."
            class="form-input border-gray-300 rounded-md w-full"
          />
          <div class="mt-2">
            <a
              href="#"
              @click.prevent="showCreateModal = true"
              class="text-green-600 hover:underline text-sm"
            >
              Caso não encontre o ponto de seção desejado, clique aqui.
            </a>
          </div>
        </div>
        <div class="col-span-4 flex items-end pb-2">
          <button
            type="button"
            class="bg-green-600 text-white h-10 px-4 rounded-md hover:bg-green-700 transition"
            @click="addSectionPoint"
          >
            ADICIONAR SEÇÃO
          </button>
        </div>
      </div>
      <!-- Modal para criação de novo ponto de seção -->
      <div
        v-if="showCreateModal"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-10"
        @click="closeModalOnOutsideClick"
      >
        <div
          class="bg-white rounded-lg shadow-lg w-full h-full 
            sm:max-w-[35vw] sm:max-h-[95vh] 
            md:max-w-[80vw] md:max-h-[80vh] 
            lg:max-w-[60vw] lg:max-h-[70vh] 
            overflow-auto p-2"
          @click.stop
        >
          <!-- Cabeçalho do Modal -->
          <div
            class="flex justify-between items-center p-4 border-b border-gray-200"
          >
            <h3 class="text-lg font-semibold text-green-800">
              Criar Novo Ponto de Seção
            </h3>
            <button
              @click="showCreateModal = false"
              class="text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon :icon="faTimes"/>
            </button>
          </div>
          <!-- Corpo do Modal -->
          <CreateSectionPoint
            :isModal="true"
            @close="showCreateModal = false"
            @created="handleSectionPointCreated"
            @cancel="showCreateModal = false"
          />
        </div>
      </div>

      <!-- Tabela de Pontos de Seção -->
      <div
        class="mb-4 shadow-md"
        style="background-color: #ffffff; border-color: #d2d6dc; border-width: 1px;"
        v-if="isMarkers"
      >
        <table class="w-full bg-white rounded border table h-px">
          <thead>
            <tr style="color: grey; background-color: #d2d6dc">
              <th
                class="py-2 px-4 uppercase text-xs font-bold p-1 text-gray-700"
              >
                PONTO DE SEÇÃO
              </th>
            </tr>
          </thead>
          <div
            v-if="origin"
            class="grid md:grid-cols-12 shadow-lg m-1 p-1"
            style="background-color: #ffffff; border-color: #d2d6dc; border-width: 1px;"
          >
            <div
              style="color: grey;"
              class="col-span-3 text-xs flex items-center justify-between py-2 border-b border-gray-200"
            >
              {{ origin.nmlocalidade }}
            </div>
            <div
              style="color: grey;"
              class="col-span-9 flex items-center justify-between py-2 border-b border-gray-200"
            >
              {{ origin.delocalidade }}
            </div>
          </div>
          <div v-if="markersForm.length > 0" class="shadow-lg">
            <div v-for="(result, index) in markersForm" :key="index">
              <div
                class="grid grid-cols-12 gap-x-2 md:grid-cols-12 shadow-lg m-1 p-1"
                style="background-color: #ffffff; border-color: #d2d6dc; border-width: 1px;"
              >
                <div
                  class="col-span-12 md:col-span-3 text-xs flex items-center justify-between py-2 border-b border-gray-200"
                >
                  {{ result.name }}
                </div>
                <div
                  class="col-span-8 md:col-span-8 flex items-center justify-between py-2 border-b border-gray-200"
                >
                  {{ result.description }}
                </div>
                <div
                  class="col-span-4 md:col-span-1 flex items-center justify-center"
                >
                  <div class="grid-container">
                    <div class="item1" @click="removeSectionPoint(index)">
                      <FontAwesomeIcon
                        class="text-red-500 cursor-pointer"
                        :icon="faTimesCircle"
                      />
                    </div>
                    <div @click="sectionPointUp(index)">
                      <FontAwesomeIcon
                        class="text-green-500 cursor-pointer"
                        :icon="faArrowUp"
                      />
                    </div>
                    <div @click="sectionPointDown(index)">
                      <FontAwesomeIcon
                        class="text-green-500 cursor-pointer"
                        :icon="faArrowDown"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="destiny"
            class="grid md:grid-cols-12 shadow-lg m-1 p-1"
            style="background-color: #ffffff; border-color: #d2d6dc; border-width: 1px;"
          >
            <div
              style="color: grey;"
              class="col-span-3 text-xs flex items-center justify-between py-2 border-b border-gray-200"
            >
              {{ destiny.nmlocalidade }}
            </div>
            <div
              style="color: grey;"
              class="col-span-9 flex items-center justify-between py-2 border-b border-gray-200"
            >
              {{ destiny.delocalidade }}
            </div>
          </div>
        </table>
      </div>

      <!-- Tabela de Seções -->
      <div class="mb-4" v-if="isSection">
        <!-- Cabeçalho Responsivo -->
        <div
          class="grid grid-cols-12 gap-4 px-3 py-2 rounded-t-md"
          style="color: grey; background-color: #d2d6dc;"
        >
          <div
            class="col-span-12 md:col-span-6 uppercase text-xs font-bold text-gray-700 text-center"
          >
            PONTO DE SEÇÃO
          </div>
          <div
            class="hidden md:block md:col-span-2 uppercase text-xs font-bold text-gray-700 text-center"
          >
            KM ASFALTO
          </div>
          <div
            class="hidden md:block md:col-span-2 uppercase text-xs font-bold text-gray-700 text-center"
          >
            KM TERRA
          </div>
          <div
            class="hidden md:block md:col-span-2 uppercase text-xs font-bold text-gray-700 text-center"
          >
            TEMPO
          </div>
        </div>

        <!-- Linhas de Dados -->
        <div
          class="shadow-md rounded-b-md"
          style="background-color: #ffffff; border-color: #d2d6dc; border-width: 1px;"
        >
          <div
            v-for="(result, index) in sections"
            :key="index"
            class="grid grid-cols-12 gap-x-4 gap-y-2 p-3 border-b"
            :style="index % 2 !== 0 ? 'background-color: #f5f5f5;' : ''"
          >
            <!-- Ponto de Seção -->
            <div
              class="col-span-12 md:col-span-6 flex items-center uppercase text-xs text-gray-700"
            >
              {{ result.origin }}
              <span class="text-gray-dark mx-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class="h-3 fill-current"
                >
                  <path
                    d="M18.59 13H3a1 1 0 0 1 0-2h15.59l-5.3-5.3a1 1 0 1 1 1.42-1.4l7 7a1 1 0 0 1 0 1.4l-7 7a1 1 0 0 1-1.42-1.4l5.3-5.3z"
                  ></path>
                </svg>
              </span>
              {{ result.destiny }}
            </div>

            <!-- KM Asfalto -->
            <div class="col-span-4 md:col-span-2">
              <label class="form-label text-xs md:hidden">KM ASFALTO</label>
              <money
                v-model="result.nukmpavimentacao"
                v-bind="kilometer"
                class="form-input w-full"
              />
            </div>

            <!-- KM Terra -->
            <div class="col-span-4 md:col-span-2">
              <label class="form-label text-xs md:hidden">KM TERRA</label>
              <money
                v-model="result.nukmterra"
                v-bind="kilometer"
                class="form-input w-full"
              />
            </div>

            <!-- Tempo -->
            <div class="col-span-4 md:col-span-2">
              <label class="form-label text-xs md:hidden">TEMPO</label>
              <money
                v-model="result.nutempopercurso"
                v-bind="minutes"
                class="form-input w-full"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Botão Criar Secionamento -->
      <div class="flex justify-end" v-if="isSection">
        <button
          type="button"
          v-if="isEdit"
          @click="cancelEdition"
          class="bg-green-600 text-white h-10 px-4 rounded-md hover:bg-green-700 transition mr-2"
        >
          CANCELAR EDIÇÃO
        </button>
        <button
          type="button"
          @click="createSeazoning"
          class="bg-green-600 text-white h-10 px-4 rounded-md hover:bg-green-700 transition"
        >
          CRIAR SECIONAMENTO
        </button>
      </div>
      <!-- Tabela de Secionamento -->
      <div v-if="isSectioning" class="mb-4">
        <!-- Cabeçalho para Telas Maiores -->
        <div
          class="hidden lg:grid lg:grid-cols-12 gap-2 text-xs font-bold uppercase p-2 rounded-t-md"
          style="color: grey; background-color: #d2d6dc;"
        >
          <div class="lg:col-span-1">#</div>
          <div class="lg:col-span-2">Origem - Destino</div>
          <div class="lg:col-span-1 text-center">Asfalto</div>
          <div class="lg:col-span-1 text-center">Terra</div>
          <div class="lg:col-span-1 text-center">Valor Base</div>
          <div class="lg:col-span-1 text-center">Coef</div>
          <div class="lg:col-span-1 text-center">Arred</div>
          <div class="lg:col-span-1 text-center">Tempo</div>
          <div class="lg:col-span-1 text-center">Manual</div>
          <div class="lg:col-span-1 text-center">Restrito</div>
          <div class="lg:col-span-1 text-center">Valor</div>
        </div>

        <!-- Corpo da Tabela Responsiva -->
        <div class="shadow-md rounded-b-md border border-gray-200">
          <div
            v-for="(result, index) in sectionPointsForm"
            :key="index"
            class="p-3 border-b last:border-b-0"
            :style="
              index % 2 !== 0
                ? 'background-color: #f5f5f5;'
                : 'background-color: #ffffff;'
            "
          >
            <div
              class="grid grid-cols-2 lg:grid-cols-12 gap-x-4 gap-y-2 text-xs"
            >
              <!-- Coluna # -->
              <div class="col-span-2 lg:col-span-1 font-bold">
                <span class="lg:hidden"># </span>
                {{ result.nusequencia }}
              </div>

              <!-- Coluna Origem-Destino -->
              <div class="col-span-2 lg:col-span-2 font-semibold">
                {{ result.origin_name }}-{{ result.destiny_name }}
              </div>

              <!-- Outras colunas em formato de lista para telas pequenas -->
              <div class="col-span-2 lg:col-span-9">
                <div
                  class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-9 gap-x-4 gap-y-2"
                >
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Asfalto: </span>
                    {{ String(result.nukmpavimentacao).replace(".", ",") }}
                  </div>
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Terra: </span>
                    {{ String(result.nukmterra).replace(".",",")}}
                  </div>
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Vl. Base: </span>
                    <span v-if="!localPatamar">
                      {{formatCurrencyBR(result.vloriginal)}}
                    </span>
                    <select
                      v-else
                      v-model="result.nuvalorcoeficientetarifa"
                      class="form-select text-xs p-1"
                      @change="handleSelectionChange(result,index)"
                    >
                      <option value="">Selecione</option>
                      <option
                        v-for="option in levels"
                        :value="option.id"
                        :key="option.id"
                      >
                        {{ option.desc }}|{{ option.value }}
                      </option>
                    </select>
                  </div>
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Coef: </span>
                    {{formatCurrencyBR(result.vlcoeficientemultiplicacao)}}
                  </div>
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Arred: </span>
                    {{formatCurrencyBR(result.vlarredondado)}}
                  </div>
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Tempo: </span>
                    {{ result.nutempopercurso }}
                  </div>
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Manual: </span>
                    <input
                      v-if="!localPatamar"
                      type="checkbox"
                      class="h-4 w-4"
                      v-model="result.flvalormanual"
                      :true-value="1"
                      :false-value="0"
                    >
                  </div>
                  <div class="lg:col-span-1 text-center">
                    <span class="font-bold lg:hidden">Restrito: </span>
                    <input
                      type="checkbox"
                      class="h-4 w-4"
                      v-model="result.flrestrito"
                      :true-value="1"
                      :false-value="0"
                    >
                  </div>
                  <div
                    class="lg:col-span-1 flex items-center lg:justify-center"
                  >
                    <span class="font-bold lg:hidden mr-2">Valor: </span>
                    <money
                      type="text"
                      v-model.lazy="result.vlpreco"
                      class="form-input text-xs p-1 max-w-[100px] mb-0"
                      @input="e => changePrice(e, result)"
                      v-bind="{ ...price,
                        disabled: !Number(result.flvalormanual) && !localPatamar}"
                      :style="{
                        'background-color': !Number(result.flvalormanual)
                          ? '#f5f5f5'
                          : ''
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botões Editar e Mapa -->
      <div class="flex justify-end space-x-3 mb-2" v-if="isSectioning">
        <button
          type="button"
          @click="EditMode()"
          class="bg-green-600 text-white h-10 px-4 rounded-md hover:bg-green-700 transition"
        >
          Editar Secionamento
        </button>
        <button
          type="button"
          @click="showMap = !showMap"
          class="bg-green-600 text-white h-10 px-4 rounded-md hover:bg-green-700 transition"
        >
          Mapa de pontos de seção
        </button>
      </div>

      <!-- Mapa -->
      <div class="w-full p-2 py-1">
        <div
          class="flex-col messageAlert"
          v-if="loaderMap"
          style="background-color: #ffffff; position: inherit; height: 100vh"
        >
          <div class="p-2">
            <img src="@/core/assets/images/loader-logo.gif">
          </div>
        </div>
        <div
          class="flex items-center w-full justify-content-center h-300"
          v-bind:class="{ 'h-500': showMap }"
        >
          <l-map
            v-if="showMap && loadTimeMap && isSectioning"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            style="z-index: 0;"
          >
            <l-tile-layer :url="url" :attribution="attribution"/>
            <div v-if="messageAlert" class="flex-col messageAlert">
              <div class="p-2">{{ textAlert }}</div>
              <div class="p-2">{{ subTextAlert }}</div>
            </div>
            <div
              v-if="loaderSearch"
              class="flex-col messageAlert"
              style="background-color: #ffffff"
            >
              <div class="p-2">
                <img src="@/core/assets/images/loader-logo.gif">
              </div>
            </div>
            <div
              class="p-2 card-info-map box-search-map"
              v-if="typePoint === 'sessionPoint'"
              @mouseover="blockAdd()"
              @mouseleave="showAdd()"
              style="border: 1px solid #d2d6dc; margin: 5px;"
            />
            <l-polyline
              :lat-lngs="linePoints"
              :color="'blue'"
              :weight="4"
            />
            <l-marker
              v-for="(marker, index) in markersForm"
              :key="index"
              :lat-lng="marker"
              :icon="icon"
            >
              <l-icon
                v-if="index === 0"
                :icon-url="firstIcon"
                :icon-size="iconSize"
              />
              <l-icon
                v-else-if="index !== markersForm.length - 1"
                :icon-url="middleIcon"
                :icon-size="iconSize"
              />
              <l-icon
                v-else
                :icon-url="lastIcon"
                :icon-size="iconSize"
              />
              <l-tooltip
                :options="{
                  permanent: false,
                  interactive: false
                }"
              >
                <div>
                  <div
                    v-if="index === 0"
                    class="tooltip-map"
                    style="color: green;"
                  >
                    {{ marker.name }}
                  </div>
                  <div
                    v-else-if="index === markersForm.length - 1"
                    class="tooltip-map first-point"
                  >
                    {{ marker.name }}
                  </div>
                  <div v-else class="tooltip-map">{{ marker.name }}</div>
                </div>
              </l-tooltip>
            </l-marker>
          </l-map>
        </div>
      </div>
    </form>
  </div>
</template>
